import React, { useContext, useRef, FC } from 'react'
import { AppDataContext } from 'providers/AppData'
import { VideoReview } from '../../../hooks/useVideoReviews'
import ReviewVideo from '../ReviewVideo'
import { Button, Container, ButtonsContainer } from './styles'
import getDomainName from '../../../utils/getDomainName'
import { Carousel, type CarouselOptions, CarouselSlide } from '@hermes/web-components'
import { purifyTenantDomain } from '../../../utils/url'

const SPLIDE_OPTIONS = {
  autoWidth: true,
  drag: 'free',
  lazyLoad: true,
  gap: '25px',
  pagination: false,
  perMove: 1,
  perPage: 1,
  arrows: false
} as CarouselOptions

type Props = {
  videoReviews: VideoReview[]
}

const VideoReviews: FC<Props> = ({ videoReviews }) => {
  const { locale } = useContext(AppDataContext)
  const myCarouselRef = useRef<any>(null)
  const domainName = getDomainName()
  const originWithLang = purifyTenantDomain(domainName, locale)

  const handleNext = () => {
    myCarouselRef.current?.go('>')
  }

  const handlePrev = () => {
    myCarouselRef.current?.go('<')
  }

  const handleClickIntroVideo = (slug: string) => {
    sessionStorage.setItem('showIntroVideo', 'true')
    window.location.assign(`${originWithLang}/specialist/${slug}`)
  }

  return (
    <Container>
      <Carousel
        options={SPLIDE_OPTIONS}
        onRefReady={(ref) => {
          myCarouselRef.current = ref
        }}
      >
        {videoReviews.map((review: VideoReview) => (
          <CarouselSlide key={review?.id}>
            <ReviewVideo
              image={review?.image}
              practitioner={review?.practitioner}
              title={review?.title}
              onClick={() => handleClickIntroVideo(review.slug)}
            />
          </CarouselSlide>
        ))}
      </Carousel>
      <ButtonsContainer>
        <Button onClick={handlePrev}>
          <img
            src="/hermes-static/icons/arrow-simple-right.svg"
            style={{
              transform: 'translateX(-50%) rotate(180deg)'
            }}
            alt="left"
          />
        </Button>
        <Button onClick={handleNext}>
          <img src="/hermes-static/icons/arrow-simple-right.svg" alt="right" />
        </Button>
      </ButtonsContainer>
    </Container>
  )
}

export default VideoReviews
